import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { id: "experience" }
const _hoisted_3 = { id: "experience-zh-section" }
const _hoisted_4 = { id: "experience-en-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { id: "introduction" }, [
      _createElementVNode("div", { id: "name-intro" }, [
        _createElementVNode("h3", null, "卢泊瑄"),
        _createElementVNode("h3", null, "Boxuan Lu")
      ]),
      _createElementVNode("div", { id: "brief-intro" }, [
        _createElementVNode("h5", null, [
          _createTextVNode(" 本科计算机科学 - 皇家墨尔本理工 2019"),
          _createElementVNode("br"),
          _createTextVNode("Bachelor of Computer Science - RMIT 2019 ")
        ]),
        _createElementVNode("h5", null, [
          _createTextVNode(" 硕士网络安全 - 莫纳什大学 2021"),
          _createElementVNode("br"),
          _createTextVNode("Master of Cyber Security - Monash 2021 ")
        ])
      ])
    ], -1)),
    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "经验", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantRecordsDetailCN, (value, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("h3", null, _toDisplayString(key), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item) => {
                return (_openBlock(), _createElementBlock("ul", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Experience", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relevantRecordsDetailEN, (value, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("h3", null, _toDisplayString(key), 1),
            _createElementVNode("ol", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item) => {
                return (_openBlock(), _createElementBlock("ul", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1))
  ]))
}